var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightButton = function SvgArrowRightButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    clipPath: "url(#clip0_2977_1448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5.5H.5v44h44z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m19 14 9 8.5-9 8.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2977_1448"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45 45H0V0h45z"
  })))));
};
export default SvgArrowRightButton;